import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonGroup, Card } from 'react-bootstrap';
import { LayoutGrid, TableIcon, FolderOpen, Coffee, Settings, Store, UtensilsCrossed, DoorOpen } from 'lucide-react';
import {
  AdminStats,
  AdminBranches,
  AdminTables,
  AdminCategories,
  AdminMenuItems,
  AdminModifierGroups,
} from '.';
import AdminBranchMenus from './AdminBranchMenus';
import PageLayout from '../../layouts/PageLayout';

const AdminMenuManagement = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const [menuSetupTab, setMenuSetupTab] = useState('categories');

  const mainTabs = [
    { id: 'overview', label: 'Tổng quan', icon: LayoutGrid },
    // { id: 'branches', label: 'Chi nhánh', icon: Store },
    { id: 'branch-menus', label: 'Menu Chi nhánh', icon: UtensilsCrossed },
    { id: 'tables', label: 'Bàn', icon: TableIcon },
    { id: 'rooms', label: 'Phòng', icon: DoorOpen },
    { id: 'menu-setup', label: 'Thiết lập thực đơn', icon: UtensilsCrossed },
  ];

  const menuTabs = [
    { id: 'categories', label: 'Danh mục', icon: FolderOpen },
    { id: 'items', label: 'Món', icon: Coffee },
    { id: 'modifiers', label: 'Tuỳ chọn', icon: Settings },
  ];

  const renderContent = () => {
    if (activeTab === 'overview') return <AdminStats />;
    // if (activeTab === 'branches') return <AdminBranches />;
    if (activeTab === 'branch-menus') return <AdminBranchMenus />;
    if (activeTab === 'tables') return <AdminTables />;
    if (activeTab === 'rooms')
      return (
        <Card className="shadow-sm">
          <Card.Body>
            <h5 className="mb-2">Cài đặt phòng đã gom về Cấu hình chi nhánh</h5>
            <p className="text-muted mb-3">
              Toàn bộ cài đặt phòng (tên phòng, sức chứa, giá/giờ, khách đặt trên app, tiện ích,
              ảnh, hành động dọn) nay nằm chung một chỗ: trang{' '}
              <strong>Cấu hình chi nhánh</strong> → khối <strong>Phòng</strong>, sửa ngay tại nút
              bút chì trên từng thẻ phòng.
            </p>
            <Button variant="primary" onClick={() => navigate('/branch-settings')}>
              <DoorOpen size={18} className="me-2" />
              Mở cài đặt phòng
            </Button>
          </Card.Body>
        </Card>
      );
    if (activeTab === 'menu-setup') {
      if (menuSetupTab === 'categories') return <AdminCategories />;
      if (menuSetupTab === 'items') return <AdminMenuItems />;
      if (menuSetupTab === 'modifiers') return <AdminModifierGroups />;
    }
    return null;
  };

  return (
    <PageLayout>
      <div className="admin-menu-management">
        <div className="mb-4">
          <h2 className="mb-3">Quản lý Menu & Thực đơn</h2>
          <div className="d-flex w-100 overflow-auto pb-1" style={{ gap: '0.25rem' }}>
            {mainTabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <Button
                  key={tab.id}
                  variant={activeTab === tab.id ? 'primary' : 'outline-secondary'}
                  onClick={() => setActiveTab(tab.id)}
                  className="d-flex align-items-center justify-content-center gap-2 text-nowrap flex-shrink-0"
                >
                  <Icon size={18} />
                  {tab.label}
                </Button>
              );
            })}
          </div>
        </div>

        {activeTab === 'menu-setup' && (
          <Card className="mb-3">
            <Card.Body className="p-2">
              <ButtonGroup className="w-100">
                {menuTabs.map((tab) => {
                  const Icon = tab.icon;
                  return (
                    <Button
                      key={tab.id}
                      variant={menuSetupTab === tab.id ? 'primary' : 'outline-secondary'}
                      onClick={() => setMenuSetupTab(tab.id)}
                      size="sm"
                      className="d-flex align-items-center justify-content-center gap-2"
                    >
                      <Icon size={16} />
                      <span className="d-none d-sm-inline">{tab.label}</span>
                    </Button>
                  );
                })}
              </ButtonGroup>
            </Card.Body>
          </Card>
        )}

        {renderContent()}
      </div>
    </PageLayout>
  );
};

export default AdminMenuManagement;
